import React from "react";
import { useTranslation } from "react-i18next";
import '../lang/i18n';
import "../styles.css";

const ErrorField = ({ meta }) => {
    const { t } = useTranslation();

    return (
        meta.touched && meta.error ? (
            <div className="error">{t(meta.error)}</div>
        ) : null
    );
};

export default ErrorField;